var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _c("md-progress", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingComponent,
            expression: "loadingComponent"
          }
        ],
        staticClass: "md-primary",
        attrs: { "md-indeterminate": "md-indeterminate" }
      }),
      _c(
        "md-theme",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingComponent,
              expression: "!loadingComponent"
            }
          ],
          attrs: { "md-name": "blue" }
        },
        [
          _c("breadcrumbs", {
            attrs: {
              id: "scrollToError",
              section: "Video Sources",
              nav: _vm.nav
            }
          }),
          _c(
            "md-layout",
            { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
            [
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("metadata-form", {
                        attrs: {
                          title: "Video Source",
                          entity: _vm.mediaSource,
                          "form-submitted": _vm.formSubmitted,
                          validations: _vm.$v.mediaSource
                        }
                      }),
                      _c("status-radio", {
                        model: {
                          value: _vm.mediaSource.status,
                          callback: function($$v) {
                            _vm.$set(_vm.mediaSource, "status", $$v)
                          },
                          expression: "mediaSource.status"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("content-targets-form", {
                        attrs: {
                          entity: _vm.mediaSource.targets,
                          "form-submitted": _vm.formSubmitted,
                          validations: _vm.$v.mediaSource.targets
                        },
                        on: {
                          created: function($event) {
                            return _vm.showAlertToast($event, "success")
                          },
                          error: function($event) {
                            return _vm.showAlertToast($event, "error")
                          }
                        }
                      }),
                      _c("playlist-selector", {
                        staticClass: "playlist-select",
                        attrs: { multiple: true },
                        model: {
                          value: _vm.mediaSource.playlists,
                          callback: function($$v) {
                            _vm.$set(_vm.mediaSource, "playlists", $$v)
                          },
                          expression: "mediaSource.playlists"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("properties-form", {
                            attrs: {
                              entity: _vm.mediaSource.setProperties,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.mediaSource.setProperties
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("ingest-settings-form", {
                            attrs: { entity: _vm.mediaSource.ingestSettings }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("feed-configuration-form", {
                        attrs: {
                          entity: _vm.mediaSource,
                          "form-submitted": _vm.formSubmitted,
                          validations: _vm.$v.mediaSource
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editMode,
                      expression: "!editMode"
                    }
                  ],
                  staticClass: "disclaimer-check",
                  attrs: {
                    "md-align": "center",
                    "md-flex": "50",
                    "md-flex-offset": "25"
                  }
                },
                [
                  _c("div", { staticClass: "md-caption" }, [
                    _vm._v(
                      "I own and/or have the right to distribute this content across domains, geographic regions, platforms, and windows of time specified in accordance with the associated licenses attached to this content or perpetually, and without restriction in the absence of attached licenses."
                    )
                  ]),
                  _c(
                    "md-checkbox",
                    {
                      staticClass: "md-primary md-body-2",
                      model: {
                        value: _vm.mediaSource.setProperties.accountHasRights,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.mediaSource.setProperties,
                            "accountHasRights",
                            $$v
                          )
                        },
                        expression: "mediaSource.setProperties.accountHasRights"
                      }
                    },
                    [_vm._v("I own or can distribute this content.")]
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100", "md-align": "center" } },
                [
                  _c("stitch-loader", {
                    attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                  }),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.creatingOrUpdating,
                          expression: "!creatingOrUpdating"
                        }
                      ],
                      staticClass: "md-raised md-primary",
                      attrs: {
                        id: "submit-btn",
                        disabled:
                          _vm.$v.$pending ||
                          !_vm.mediaSource.setProperties.accountHasRights,
                        "md-theme": "blue"
                      },
                      on: { click: _vm.onFormSubmit }
                    },
                    [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e262a82", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e262a82","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/mediaSource/MediaSourceForm.vue
// module id = 984
// module chunks = 0